import styled from 'styled-components'
import Container from '@components/styled/Container'
import ScrolledSentecesWheel from '@components/ScrolledSentences/ScrolledSentecesWheel'
import { down } from 'styled-breakpoints'

type IProps = {
  title: string
  sentences: Array<string>
  unchangedWord: string
}

const StyledTitle = styled.p`
  text-align: center;
  margin-bottom: 3rem;
`

const StyledScrolledSentences = styled.div`
  background: #000;
  color: #fff;
  padding: 20rem 0 25rem;
  overflow: hidden;

  ${down('lg')} {
    padding: 15rem 0 20rem;
  }

  ${down('lg')} {
    padding: 5rem 0 10rem;
  }
`

const StyledSentencesContainer = styled.div`
  letter-spacing: -0.1px;
  font-weight: 400;
  display: grid;
  grid-template-columns: max-content 6fr;
  align-items: center;
  column-gap: 8.5rem;

  ${down('lg')} {
    column-gap: 5.6rem;
  }

  ${down('md')} {
    column-gap: 3rem;
  }

  * {
    font-size: 8rem;
    line-height: 11.2rem;
    margin: 0;

    ${down('lg')} {
      font-size: 6rem;
      line-height: 6rem;
    }

    ${down('md')} {
      font-size: 4rem;
      line-height: 4rem;
    }

    ${down('xs')} {
      font-size: 2rem;
      line-height: 2rem;
    }
  }
`

const StyledSentences = styled.div`
  margin-top: 3rem;

  ${down('lg')} {
    margin-top: 2.5rem;
  }

  ${down('md')} {
    margin-top: 1.5rem;
  }

  ${down('sm')} {
    margin-top: 3.5rem;
  }
`

const ScrolledSentences: React.FC<IProps> = ({
  title,
  unchangedWord,
  sentences,
}: IProps) => {
  return (
    <StyledScrolledSentences>
      <Container>
        <StyledTitle>{title}</StyledTitle>
        <StyledSentencesContainer>
          <span>{unchangedWord}</span>
          <StyledSentences>
            <ScrolledSentecesWheel values={sentences} />
          </StyledSentences>
        </StyledSentencesContainer>
      </Container>
    </StyledScrolledSentences>
  )
}

export default ScrolledSentences
